import { SafetyDataSheet } from './SafetyDatasheet';
export default SafetyDataSheet;
